import React from 'react';

import { Link } from '@shared-legacy/ui-kit';
import { getSafeExternalHref } from '@shared/lib/utils';

import { cn } from './cn';

export interface SafeExternalLinkProps extends Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> {
  href: string;
  children: React.ReactNode;
}

export const SafeExternalLink = (props: SafeExternalLinkProps) => {
  const { href, children, className, target = '_blank', rel = 'noopener noreferrer', ...restProps } = props;
  const safeHref = getSafeExternalHref(href);

  if (!safeHref) {
    return <span className={cn(className)}>{children}</span>;
  }

  return (
    <Link href={safeHref} className={className} target={target} rel={rel} {...restProps}>
      {children}
    </Link>
  );
};
